var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Autorenew",
    clipPath: "url(#clip0_2751_54968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 5.9997V7.7897C12 8.2397 12.54 8.4597 12.85 8.1397L15.64 5.3497C15.84 5.1497 15.84 4.8397 15.64 4.6397L12.85 1.8497C12.54 1.5397 12 1.7597 12 2.2097V3.9997C7.58 3.9997 4 7.5797 4 11.9997C4 13.0397 4.2 14.0397 4.57 14.9497C4.84 15.6197 5.7 15.7997 6.21 15.2897C6.48 15.0197 6.59 14.6097 6.44 14.2497C6.15 13.5597 6 12.7897 6 11.9997C6 8.6897 8.69 5.9997 12 5.9997ZM17.79 8.7097C17.52 8.9797 17.41 9.3997 17.56 9.7497C17.84 10.4497 18 11.2097 18 11.9997C18 15.3097 15.31 17.9997 12 17.9997V16.2097C12 15.7597 11.46 15.5397 11.15 15.8597L8.36 18.6497C8.16 18.8497 8.16 19.1597 8.36 19.3597L11.15 22.1497C11.46 22.4597 12 22.2397 12 21.7997V19.9997C16.42 19.9997 20 16.4197 20 11.9997C20 10.9597 19.8 9.9597 19.43 9.0497C19.16 8.3797 18.3 8.1997 17.79 8.7097Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2751_54968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.545d71a1af5a5618968ab6caa999780e.svg";
export { ForwardRef as ReactComponent };